<template>
    <div>
        <language></language>

        <div class="error" v-if="hasError">
            {{ $t(`${errorMessage}`) }}
        </div>

        <div class="wrapper">

            <div class="container disabled" v-bind:class="{ shake: hasError }">

                <div class="logo">
                    <img src="@/assets/images/icon.png" alt="logo" />
                </div>

                <div class="form">

                    <div class="row">

                        <div class="column-100">

                            <label for="username">
                                <fa-icon class="placeholder-icon" :icon="['fal', 'user']" />
                                <input type="text" :placeholder="$t('USERNAME')" id="username" name="username" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" v-model="username" disabled />
                            </label>

                        </div>

                    </div>

                    <div class="row">

                        <div class="column-100">

                            <label for="password">
                                <fa-icon class="placeholder-icon" :icon="['fal', 'lock']" />
                                <input type="password" :placeholder="$t('PASSWORD')" id="password" name="password" v-model="password" disabled />
                            </label>

                        </div>

                    </div>

                    <div class="row">

                        <div class="column-100">

                            <button class="btn width-100" v-on:click="authenticate()" disabled>
                                <span>{{ $t('LOG_IN') }}</span>
                            </button>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div class="applications">
            <application url="https://developer.mostwanted.io" :doc="true" name="developer" title="Developer" description="DEVELOPER_DESCRIPTION"></application>
            <application url="https://vplan.nl" :doc="true" doc-alternative="https://developer.vplan.nl/documentation/" name="vplan" title="vPlan" description="VPLAN_DESCRIPTION"></application>
            <application url="https://fs.mostwanted.io" :doc="true" name="fs" title="Flying Squirrel" description="FS_DESCRIPTION"></application>
            <application url="https://chronicle.mostwanted.io" :doc="true" name="chronicle" title="Chronicle" description="CHRONICLE_DESCRIPTION"></application>
            <application url="https://grapple.mostwanted.io" :doc="true" name="grapple" title="Grapple" description="GRAPPLE_DESCRIPTION"></application>
            <application url="https://sneakpeak.mostwanted.io" :doc="true" name="sneakpeak" title="SneakPeak" description="SNEAKPEAK_DESCRIPTION"></application>
        </div>

        <div class="footer">
            <p v-html="copyright"></p>
            <p>{{ version }}</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/base.scss';

.error
{
    position: fixed;
    top: 0;
    width: 100%;

    background: $red-color;

    text-align: center;

    padding: 10px;

    color: $lighter-color;
}

.wrapper
{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    align-items: top;
    justify-content: center;

    padding-top: 100px;

    .container
    {
        display: inline-block;

        box-sizing: border-box;
        padding: 10px;

        border-radius: 3px;

        width: 400px;
        max-width: 400px;

        min-width: 200px;

        background: $background;

        .logo
        {
            text-align: center;
        }

        .row
        {
            margin: 0px -10px;
            width: auto;

            &:before, &:after
            {
                content: " ";
                display: table;

                clear: both;
                box-sizing: border-box;
            }

            .column-100
            {
                position: relative;
                width: 100%;

                padding: 0px 10px;
                box-sizing: border-box;
            }
        }

        .width-100
        {
            width: 100%;
        }

        label
        {
            position: relative;

            .placeholder-icon
            {
                position: absolute;

                top: 0px;
                left: 0px;

                z-index: 2;

                padding-left: 10px;
                padding-top: 12px;
            }

            input[type="text"], input[type="password"]
            {
                width: 100%;

                display: block;
                box-sizing: border-box;

                margin: 0px 0px 2px 0px;
                padding: 10px 10px 10px 30px;

                height: 40px;

                background: $lighter-color;

                border: 1px solid $light-color;
                border-radius: 3px;

                outline: none;

                font-size: 1em;
                color: $darker-color;

                appearance: none;
                -webkit-appearance: none;
            }
        }

        .btn
        {
            margin-top: 10px;

            border-radius: 5px;
        }
    }

    .shake
    {
        animation: shake 0.75s;
    }

    .disabled
    {
        opacity: 0.5;
        pointer-events: none;
    }
}

.applications
{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    align-items: top;
    justify-content: center;

    margin: 40px;
}

.footer
{
    position: fixed;
    bottom: 0;
    width: 100%;

    text-align: center;

    padding: 10px;

    font-size: 75%;
    color: $dark-color;

    p
    {
        margin: 2px;
    }
}

@keyframes shake
{
    0%, 100% {transform: translateX(0);}
    10%, 30%, 50%, 70%, 90% {transform: translateX(-10px);}
    20%, 40%, 60%, 80% {transform: translateX(10px);}
}
</style>

<script>
import store from '@/store';
import router from '@/router';

import Application from '@/modules/application/Application';
import Language from '@/modules/language/Language';

import app from '@/../package.json';

export default {
    name: 'Authentication',
    components: {
        Application,
        Language,
    },
    data: () =>
    {
        return {
            username: '',
            password: '',
            hasError: false,
            errorMessage: 'ERROR',
            copyright: '&copy; Most Wanted Software ' + new Date().getFullYear() === '2015' ? '2015' : '2015 - ' + new Date().getFullYear(),
            version: 'v' + app.version,
        };
    },
    methods: {
        authenticate: function()
        {
            if (this.username !== '' && this.password !== '')
            {
                store.dispatch(
                    'authenticate',
                    {
                        username: this.username,
                        password: this.password,
                    }
                ).then(
                    () =>
                    {
                        router.push({path: '/'});
                    },
                    (rejection) =>
                    {
                        this.errorMessage = rejection || 'ERROR';

                        this.hasError = true;
                    }
                );
            }
            else
            {
                this.hasError = true;
            }

            setTimeout(() =>
            {
                this.hasError = false;
            }, 10000);
        },
    },
};
</script>
